/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Trade_CategoryInputs */

const en_field_trade_category = /** @type {(inputs: Field_Trade_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trade`)
};

const es_field_trade_category = /** @type {(inputs: Field_Trade_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oficio`)
};

const fr_field_trade_category = /** @type {(inputs: Field_Trade_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métier`)
};

const de_field_trade_category = /** @type {(inputs: Field_Trade_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewerbe`)
};

const ja_field_trade_category = /** @type {(inputs: Field_Trade_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`業種`)
};

const zh_field_trade_category = /** @type {(inputs: Field_Trade_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`贸易类别`)
};

const ar_field_trade_category = /** @type {(inputs: Field_Trade_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحرفة`)
};

const id_field_trade_category = /** @type {(inputs: Field_Trade_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdagangan`)
};

const it_field_trade_category = /** @type {(inputs: Field_Trade_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria Artigianato/Professione`)
};

const ru_field_trade_category = /** @type {(inputs: Field_Trade_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Категория услуг/ремонта`)
};

const pt_field_trade_category = /** @type {(inputs: Field_Trade_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofício / Serviço`)
};

const ko_field_trade_category = /** @type {(inputs: Field_Trade_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업종`)
};

/**
* | output |
* | --- |
* | "Trade" |
*
* @param {Field_Trade_CategoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_trade_category = /** @type {((inputs?: Field_Trade_CategoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Trade_CategoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_trade_category(inputs)
	if (locale === "es") return es_field_trade_category(inputs)
	if (locale === "fr") return fr_field_trade_category(inputs)
	if (locale === "de") return de_field_trade_category(inputs)
	if (locale === "ja") return ja_field_trade_category(inputs)
	if (locale === "zh") return zh_field_trade_category(inputs)
	if (locale === "ar") return ar_field_trade_category(inputs)
	if (locale === "id") return id_field_trade_category(inputs)
	if (locale === "it") return it_field_trade_category(inputs)
	if (locale === "ru") return ru_field_trade_category(inputs)
	if (locale === "pt") return pt_field_trade_category(inputs)
	return ko_field_trade_category(inputs)
});